/**
 * Reporting sidebar suites (RCS-131). Mirrors ReportCatalogue::SUITES on the
 * API — the key is the suite slug the API serves at /reporting/suites/{key}.
 * Each suite gets its own named route so the sidebar highlights correctly.
 */
export interface ReportingSuite {
  key: string;
  routeName: string;
  path: string;
  label: string;
  categories: string[];
}

export const REPORTING_SUITES: ReportingSuite[] = [
  { key: "enterprise-risk", routeName: "reporting.enterprise-risk", path: "/reporting/enterprise-risk", label: "Enterprise Risk", categories: ["risk", "kpi"] },
  { key: "regulatory-compliance", routeName: "reporting.regulatory-compliance", path: "/reporting/regulatory-compliance", label: "Regulatory Compliance", categories: ["compliance", "regulatory"] },
  { key: "internal-policy-compliance", routeName: "reporting.internal-policy-compliance", path: "/reporting/internal-policy-compliance", label: "Internal Policy Compliance", categories: ["policy_compliance"] },
  { key: "controls", routeName: "reporting.controls", path: "/reporting/controls", label: "Controls", categories: ["controls"] },
  { key: "incidents-breaches", routeName: "reporting.incidents-breaches", path: "/reporting/incidents-breaches", label: "Incidents & Breaches", categories: ["incident"] },
  { key: "fraud", routeName: "reporting.fraud", path: "/reporting/fraud", label: "Fraud", categories: ["fraud"] },
  { key: "capa", routeName: "reporting.capa", path: "/reporting/capa", label: "CAPA", categories: ["capa"] },
  { key: "audit", routeName: "reporting.audit", path: "/reporting/audit", label: "Audit", categories: ["audit"] },
  { key: "regulatory-returns", routeName: "reporting.regulatory-returns", path: "/reporting/regulatory-returns", label: "Regulatory Returns", categories: ["regulatory_returns"] },
];

/** Every report category with a display label, for filters and badges. */
export const REPORT_CATEGORY_LABELS: Record<string, string> = {
  risk: "Enterprise Risk",
  kpi: "KRI",
  compliance: "Compliance",
  regulatory: "Regulatory Omnibus",
  policy_compliance: "Internal Policy",
  controls: "Controls",
  incident: "Incidents & Breaches",
  fraud: "Fraud",
  capa: "CAPA",
  audit: "Audit",
  regulatory_returns: "Regulatory Returns",
  board: "Board Governance",
};

/** Where a report of this category "lives" — used for Back navigation. */
export function homeRouteForCategory(category?: string | null): { name: string } {
  if (category === "board") return { name: "board.governance-reports" };
  const suite = REPORTING_SUITES.find((s) => category && s.categories.includes(category));
  return { name: suite ? suite.routeName : "reports.generated" };
}

/** Period presets shared by the report builder and the schedule form. */
export const REPORT_PERIODS = [
  { value: "current_week", label: "Current Week" },
  { value: "previous_week", label: "Previous Week" },
  { value: "current_month", label: "Current Month" },
  { value: "previous_month", label: "Previous Month" },
  { value: "current_quarter", label: "Current Quarter" },
  { value: "previous_quarter", label: "Previous Quarter" },
  { value: "ytd", label: "Year to Date" },
  { value: "previous_year", label: "Previous Year" },
  { value: "custom", label: "Custom Range" },
];
